import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { maskConfig, moneyMaskWithoutDecimal } from '@libraries/ui';
import { isDesktop } from '@libraries/ui-state';
import { select, Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import {
  calculateMonthlyCost,
  checkAnotherProperty,
  estimatedCost,
  estimatedProjectCostInformation,
  isLoading,
  propertyAddress,
} from '../+state';
import { PropertyAddress } from '../models';

@Component({
  selector: 'property-is-eligible',
  templateUrl: './property-is-eligible.component.html',
  styleUrls: ['./property-is-eligible.component.scss'],
  standalone: false,
})
export class PropertyIsEligibleComponent implements OnInit {
  address: PropertyAddress;
  costForm: UntypedFormGroup;
  moneyMaskWithoutDecimal = moneyMaskWithoutDecimal;
  maskConfig = maskConfig;
  estimatedCost$ = this.store.pipe(select(estimatedCost));
  estimatedCostInfo$ = this.store.pipe(select(estimatedProjectCostInformation));
  isDesktop$ = this.store.pipe(select(isDesktop));
  isLoading$ = this.store.pipe(select(isLoading));

  constructor(private fb: UntypedFormBuilder, private store: Store) {}

  ngOnInit() {
    this.store
      .pipe(select(propertyAddress), take(1))
      .subscribe((address) => (this.address = address));

    this.costForm = this.fb.group({
      estimated_cost: [
        null,
        {
          // any better fix than adding updateOn?
          updateOn: 'focus',
          validators: [Validators.required, Validators.min(5000), Validators.max(100000000)],
        },
      ],
    });
  }

  submit() {
    this.costForm.markAllAsTouched();
    if (this.costForm.invalid) return;
    const payload = {
      address: this.address,
      ...this.costForm.value,
      include_apr: true,
    };
    this.store.dispatch(calculateMonthlyCost({ payload }));
  }

  formattedAddressForDisplay() {
    if (this.address) {
      if (this.address.line_2) {
        return `${this.address.line_1} ${this.address.line_2}, ${this.address.city}, ${this.address.state}`;
      }
      return `${this.address.line_1}, ${this.address.city}, ${this.address.state}`;
    }
  }

  navigate() {
    this.store.dispatch(checkAnotherProperty());
  }
}
